import usePropertyService from 'api/services/propertyService'
import Loading from 'components/common/loading/Loading'
import PropertyCard from 'components/propertyCard/PropertyCard'
import useListingFavorite from 'components/propertyCard/useListingFavorite'
import { useTranslation } from 'react-i18next'
import { useQuery } from 'react-query'
import { useNavigate } from 'react-router-dom'
import { ListedProperty } from 'types/property'

const LatestBails = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { loadListedProperties } = usePropertyService()

  const { data, isLoading } = useQuery<ListedProperty[] | undefined>(
    'latestProperties',
    () => loadListedProperties(),
    { staleTime: 5 * 60_000 }
  )

  const latestProperties = Array.isArray(data) ? data.slice(0, 3) : []

  const { handleFavorite, loadingFavoriteId } = useListingFavorite({
    properties: latestProperties,
  })

  if (isLoading) {
    return (
      <section className="bg-imovWhite py-16">
        <div className="max-w-6xl mx-auto px-4">
          <Loading />
        </div>
      </section>
    )
  }

  if (!latestProperties.length) {
    return null
  }

  return (
    <section className="bg-imovWhite py-16">
      <div className="max-w-6xl mx-auto px-4">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-imovSecondary mb-3">
            {t('home.currentLeasesTitle')}
          </h2>
          <p className="text-sm md:text-base text-imovSecondary/80">
            {t('home.currentLeasesSubtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {latestProperties.map((property, index) => (
            <div key={property.id}>
              <PropertyCard
                property={property}
                currentIndex={null}
                listIndex={index}
                loadingFavoriteId={loadingFavoriteId}
                handleFavorite={handleFavorite}
                className="w-full min-w-0"
                handleClick={() =>
                  navigate(`/listing/${property.id}`, {
                    state: { returnTo: '/listings' },
                  })
                }
              />
            </div>
          ))}
        </div>

        <div className="mt-10 flex justify-center">
          <button
            type="button"
            onClick={() => navigate('/listings')}
            className="inline-flex items-center justify-center px-6 py-3 rounded-full border border-imovSecondary/20 bg-white text-imovSecondary text-sm md:text-base font-medium shadow-sm hover:bg-imovWhite hover:shadow-md transition-all"
          >
            {t('home.seeAllLeases', 'Voir tous les baux disponibles')}
            <span className="ml-2 text-base">➜</span>
          </button>
        </div>
      </div>
    </section>
  )
}

export default LatestBails
